import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { isNumber, toInteger } from './ngb-util';
import * as dayjs from 'dayjs';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  static dateFormat = 'MM/DD/YY';

  static setDateFormat(format: string) {
    this.dateFormat = format;
  }
  static resetDateFormat() {
    this.dateFormat = 'MM/DD/YY';
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('-');
      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return { day: toInteger(dateParts[0]), month: null, year: null };
      } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: null };
      } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2]) };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date
      ? dayjs()
          .month(date.month - 1)
          .date(date.day)
          .year(date.year)
          .format(NgbDateCustomParserFormatter.dateFormat)
      : '';
  }
}
